import { render, staticRenderFns } from "./cookie-notification.vue?vue&type=template&id=3ebb06f0&scoped=true"
import script from "./cookie-notification.vue?vue&type=script&lang=js"
export * from "./cookie-notification.vue?vue&type=script&lang=js"
import style0 from "./cookie-notification.vue?vue&type=style&index=0&id=3ebb06f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebb06f0",
  null
  
)

export default component.exports